import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const GTMPageView = () => {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};

export default GTMPageView;
